<template>
  <img src="/imgs/alipayhk.png" class="w-6 h-6 inline-block rounded" />
</template>

<script>
export default {};
</script>
